module.exports = class ShowCtrl
  constructor: (FeedbackService, $stateParams) ->
    'ngInject'

    @feedback = FeedbackService.one($stateParams.id).get().$object

